import { CALL_API } from '../../../middleware/api';
import * as API from '../../../services/ApiEndpointsConstants';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as SightingsConstants from './SightingsConstants';

export function getImageComments(messageName) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(
        API.GET_IMAGE_COMMENTS
      )}/${messageName}`,
      types: [
        SightingsConstants.GET_IMAGE_COMMENTS_REQUEST,
        SightingsConstants.GET_IMAGE_COMMENTS_SUCCESS,
        SightingsConstants.GET_IMAGE_COMMENTS_FAILED
      ]
    }
  };
}

export function addMessageToOneImage(requestData) {
  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: requestData,
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints().entity(API.ADD_MSG_TO_ONE_IMAGE),
      types: [
        SightingsConstants.ADD_MSG_TO_ONE_IMAGE_REQUEST,
        SightingsConstants.ADD_MSG_TO_ONE_IMAGE_SUCCESS,
        SightingsConstants.ADD_MSG_TO_ONE_IMAGE_FAILED
      ]
    }
  };
}

export function addMessageToAllImages(domainId, requestData) {
  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: requestData,
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: `${apiEndpoints().entity(
        API.ADD_MSG_TO_ALL_IMAGES
      )}/${domainId}`,
      types: [
        SightingsConstants.ADD_MSG_TO_ALL_IMAGES_REQUEST,
        SightingsConstants.ADD_MSG_TO_ALL_IMAGES_SUCCESS,
        SightingsConstants.ADD_MSG_TO_ALL_IMAGES_FAILED
      ]
    }
  };
}
